<template>
  <div>
    <label v-if="label" v-bind="labelBindings">{{ label }}</label>
    <input type="date" v-bind="inputBindings" v-on="inputEvents">
    <p v-if="invalid" class="text-danger">{{ errorMessage }}</p>
  </div>
</template>
<script>
import BaseInput from './BaseInput'

export default {
  extends: BaseInput
}
</script>